/**
 * URL State Context
 *
 * Provides URL-based state management to the entire app
 */

import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { useURLState } from "@/hooks/useURLState";
import type { DashboardState } from "@/lib/routing/types";

interface URLStateContextType {
  state: DashboardState;
  updateState: (updates: Partial<DashboardState>) => void;
}

const URLStateContext = createContext<URLStateContextType | undefined>(
  undefined
);

export function URLStateProvider({ children }: { children: ReactNode }) {
  const { state, updateState } = useURLState();

  return (
    <URLStateContext.Provider value={{ state, updateState }}>
      {children}
    </URLStateContext.Provider>
  );
}

function useURLStateContext() {
  const context = useContext(URLStateContext);
  if (!context) {
    throw new Error("useURLStateContext must be used within URLStateProvider");
  }
  return context;
}
